import { Component, OnInit, ViewEncapsulation, Renderer2, OnDestroy } from '@angular/core';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { Router, ActivatedRoute } from '@angular/router';
import { NgbModal, ModalDismissReasons } from '@ng-bootstrap/ng-bootstrap';
import { UserService } from '../services/user.service';
import { VisionService } from '../services/vision.service';
import { CriteriaService } from '../services/criteria.service';
import { JobService } from '../services/job.service';
import { SpinnerService } from '../services/spinner';
import { VisionModel } from '../models/vision.model';
import { SurveyTypes } from '../models/surveytypes';
import { SurveyDetails } from '../models/dto/survey';
import { CriteriaDetails } from '../models/dto/criteria';
import { AnswersAddDetails } from '../models/dto/answers';

@Component({
    selector: 'app-job-create',
    templateUrl: './jobs-create.component.html',
    styleUrls: ['./jobs-create.component.scss'],
    encapsulation: ViewEncapsulation.None
})

export class JobsCreateComponent implements OnInit, OnDestroy {
    closeResult: string;
    current_survey: any;
    user_data: any;
    email: any;
    visionId: string;
    survey_data: SurveyDetails;
    visionTypeId: number;
    changeVisionType = false;
    criterias_all: Array<CriteriaDetails>;
    vision_title: string;
    title: string; company: string; reference: string; localite: string;
    formFieldsInvalid = false;
    criteriaCount = 0;
    compCrtId = '';  // complete criteria ID
    compCriteriaTitle = '';   // complete criteria title
    firstFormIsValid = false;
    condTitle = '';
    selectedOptionsModelArray: Array<AnswersAddDetails> = [];
    selectedCriteriasCount = 0;
    selectedPrecentage = 0;
    progressColor = 'prgrs-bg-dark-orange';
    isStarted = false;
    isNotCompleted = true;
    registerText = "Êtes-vous certain(e) d'avoir passé en revue tous vos critères ?";
    selectedRadio = 0;
    jobsForm: FormGroup;
    jobTitle: FormControl; jobCompany: FormControl; jobPlace: FormControl; jobReference: FormControl; editCrtId: FormControl;
    conditionsForm: FormGroup;
    optTitle: FormControl; conditionRadio: FormControl; checkAllCriterias: FormControl;


    constructor(private visionService: VisionService, private criteriaService: CriteriaService,
        private renderer: Renderer2,
        private jobService: JobService, private modalService: NgbModal, private router: Router, private route: ActivatedRoute,
        private visionModel: VisionModel, private surveyTypes: SurveyTypes, private spinnerService: SpinnerService) {

        this.renderer.addClass(document.body, 'container_bg-jadd');
        const currentSurvey = localStorage.getItem('current_survey');
        const visionTitle = localStorage.getItem('vision_title');
        this.user_data = localStorage.getItem('user_data');
        // Check login
        if (this.user_data != null && this.user_data !== 'null') {
            this.user_data = JSON.parse(this.user_data);
            this.email = this.user_data.email;
        } else {
            this.router.navigateByUrl('home/user');
        }
        if (visionTitle && visionTitle !== 'null') {
            // do nothing
        } else {
            this.router.navigateByUrl('home/user');
        }
        if (currentSurvey && currentSurvey !== 'null') {
            this.current_survey = JSON.parse(currentSurvey);
            this.vision_title = this.current_survey.title;
        } else {
            this.setCurrentVision();
        }
    }

    ngOnInit() {
        this.route.params.subscribe(params => {
            if (params['visiontype']) {
                this.visionTypeId = params['visiontype'];
                this.changeVisionType = true;
            }
        });
        if (this.changeVisionType) {
            this.changeCurrentVision();
        }
        this.jobTitle = new FormControl('jobTitle', [Validators.required, Validators.maxLength(100)]);
        this.jobCompany = new FormControl('jobCompany', [Validators.required, Validators.maxLength(100)]);
        this.jobPlace = new FormControl('jobPlace', [Validators.required, Validators.maxLength(100)]);
        this.jobReference = new FormControl('jobReference', [Validators.maxLength(100)]);
        this.editCrtId = new FormControl('');
        this.jobsForm = new FormGroup({
            jobTitle: this.jobTitle,
            jobCompany: this.jobCompany,
            jobPlace: this.jobPlace,
            jobReference: this.jobReference,
            editCrtId: this.editCrtId,
        });
        this.optTitle = new FormControl('', [Validators.required, Validators.maxLength(100)]);
        this.conditionRadio = new FormControl('', Validators.required);
        this.checkAllCriterias = new FormControl('');
        this.conditionsForm = new FormGroup({
            optTitle: this.optTitle,
            conditionRadio: this.conditionRadio,
            checkAllCriterias: this.checkAllCriterias,
        });
        this.getCriterias();
    }
    ngOnDestroy() {
        this.renderer.removeClass(document.body, 'container_bg-jadd');
    }

    getCriterias() {
        if (this.current_survey) {
            this.visionId = this.current_survey.id;
            this.visionService.getVisionData(this.visionId).subscribe(result => {
                this.survey_data = result.Survey;
                this.criterias_all = this.survey_data.criterias;
                this.criteriaCount = this.survey_data.criterias.length;
            });
        }
    }

    referenceChange(refValue) {
        if (this.jobsForm.valid) {
            this.firstFormIsValid = true;
        } else {
            this.firstFormIsValid = false;
        }
    }
    reCheckFirstForm() {
        if (this.jobsForm.valid) {
            this.firstFormIsValid = true;
        } else {
            this.firstFormIsValid = false;
        }
    }
    clearTitle(formTitleNumber) {
        if (formTitleNumber === 1) {
            this.title = '';
        }
    }
    cancelJobCreate() {
        this.router.navigateByUrl('vision/jobs'); // redirect after adding options
    }
    closePopupModal() {
        document.getElementById('closeModalButton').click();
    }
    open(content) {
        this.modalService.open(content).result.then(
            result => {
                this.closeResult = `Closed with: ${result}`;
            },
            reason => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }
    openAddCondition(content) {
        this.modalService.open(content, { windowClass: 'jadd-modal' }).result.then(
            result => {
                this.closeResult = `Closed with: ${result}`;
            },
            reason => {
                this.closeResult = `Dismissed ${this.getDismissReason(reason)}`;
            }
        );
    }
    openEmptyModal(content) {
        this.modalService.open(content, { windowClass: 'jobAdd-emptyMod' });
    }

    private getDismissReason(reason: any): string {
        if (reason === ModalDismissReasons.ESC) {
            return "by pressing ESC";
        } else if (reason === ModalDismissReasons.BACKDROP_CLICK) {
            return "by clicking on a backdrop";
        } else {
            return `with: ${reason}`;
        }
    }

    onCrTemplateChange(formOutput: any) {
        const answersModel: AnswersAddDetails = new AnswersAddDetails(formOutput[0].crt, formOutput[0].selectedOptions);
        this.deleteFromArray(answersModel.CriteriaId);
        if (answersModel.Options.length < 1) {
            // if unchecked then options empty
        } else {
            this.reCheckFirstForm();
            this.selectedOptionsModelArray.push(answersModel); // add to selected array
        }
        this.selectedCriteriasCount = this.selectedOptionsModelArray.length;
        this.selectedCalculations();
    }

    deleteFromArray(crtId: string) {
        const selectedItem = this.selectedOptionsModelArray.filter(x => x.CriteriaId === crtId)[0];
        if (selectedItem) {
            const index: number = this.selectedOptionsModelArray.indexOf(selectedItem);
            if (index !== -1) {
                this.selectedOptionsModelArray.splice(index, 1);
            }
        }
    }


    selectedCalculations() {
        if (this.selectedCriteriasCount >= 1) {
            this.isStarted = true;
        }
        if (this.criteriaCount > this.selectedCriteriasCount) {
            this.registerText = "Êtes-vous certain(e) d'avoir passé en revue tous vos critères ?";
        } else {
            this.registerText = "Vous avez fini d'étudier cette offre ?";
        }
        this.selectedPrecentage = +((this.selectedCriteriasCount / this.criteriaCount) * 100).toFixed(0);
        if (this.selectedPrecentage <= 20) {
            this.progressColor = 'prgrs-bg-dark-orange';
            this.isNotCompleted = true;
        } else if (this.selectedPrecentage <= 70) {
            this.progressColor = 'prgrs-bg-orange';
            this.isNotCompleted = false;
        } else if (this.selectedPrecentage > 70) {
            this.progressColor = 'prgrs-bg-green';
            this.isNotCompleted = false;
        }
    }
    changeRadioValue(value) {
        this.selectedRadio = value;
    }

    openCompleter(crtId) {
        this.compCrtId = crtId;
        const selCriteria = this.criterias_all.filter(x => x.id === crtId)[0];
        if (selCriteria) {
            this.compCriteriaTitle = selCriteria.title;
        }
    }
    styleProgress() {
        return { width: this.selectedPrecentage + '%' };
    }
    changeCurrentVision() {
        this.visionModel.setSurveyInStorageFromType(this.visionTypeId).subscribe(data => {
            this.current_survey = JSON.parse(localStorage.getItem('current_survey'));
            localStorage.setItem('vision_title', this.vision_title);
            this.getCriterias();
        });
    }
    setCurrentVision() {
        const visionTitle = localStorage.getItem('vision_title');
        const visionTypeId = this.surveyTypes.getTitleId(visionTitle);
        this.visionTypeId = visionTypeId;
        this.visionModel.setSurveyInStorageFromType(visionTypeId).subscribe(data => {
            this.current_survey = JSON.parse(localStorage.getItem('current_survey'));
            this.vision_title = this.current_survey.title;
            localStorage.setItem('vision_title', this.vision_title);
            this.getCriterias();
        });
    }

    registerCondition() {
        const condradio: number = +this.conditionsForm.get('conditionRadio').value;
        this.criteriaService.addNewOption(this.conditionsForm.get('optTitle').value, condradio, this.compCrtId).subscribe(result => {
            document.getElementById('closeModalButton').click();
        });
    }

    registerJob() {
        // more validations
        let addRefrence = this.reference;
        if (this.title === '' || this.visionId === '' || this.company === '' || this.jobsForm.invalid) {
            return;
        }
        if (!addRefrence || addRefrence === '') {
            addRefrence = ' ';
        }
        this.spinnerService.show();
        const answersIds: Array<string> = [];
        let allMutations = `mutation {`;
        this.jobService.addNewJob(this.title, this.visionId, this.company, this.localite, addRefrence).subscribe(({ data }: any) => {
            const offerId = data.createOffer.id;
            let indexAnswer = 0;
            this.selectedOptionsModelArray.forEach(criterias => {
                const criteriaId = criterias.CriteriaId;
                criterias.Options.forEach(option => {
                    indexAnswer++;
                    allMutations += this.jobService.buildAddAnswer(indexAnswer, criteriaId, offerId, option);
                });
            });
            allMutations += ' }';
            this.jobService.mutateEditOffer(allMutations).subscribe(resp => {
                this.spinnerService.hide();
                this.router.navigateByUrl('vision/jobs'); // redirect after adding job offer
            });
        });
    }

}



// WEBPACK FOOTER //
// /var/www/angular/mobilit-web/src/app/jobs/jobs-create.component.ts